import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { TYPOGRAPHY } from "@store/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

// TODO: ISA REFACTOR
merge(quantityOrderedStyles, {
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                input {
                    width: 60px !important;
                    color: #000 !important;
                    height: 49px;
                    padding: 0 9px !important;
                    text-align: center;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                width: 60px;
                                display: inline-block;
                                margin-right: 2%;
                                padding: 0 5px;
                                font-size: ${TYPOGRAPHY.size.smaller};
                                height: 54px;
                            `,
                            css``,
                            css`
                                float: none;
                                display: inline-block;
                            `,
                            css``,
                            css``,
                        ],
                        "min",
                    )}
            `,
        },
        label: null,
    },
});
